import { render } from "./NavButton.vue?vue&type=template&id=a1c88a3e"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__